export default __webpack_public_path__ + "static/media/audio1.20659d7c.mp3";